import type { AITaskSuggestion as AITaskSuggestionType } from '@/models/ai/types';
import { AITaskSuggestion } from '@/models/registry';
import dayjs from 'dayjs';
import { makeAutoObservable } from 'mobx';
import { v4 as uuidv4 } from 'uuid';

class AITaskSuggestions {
  // <suggestion id, suggestion>
  store: Map<string, AITaskSuggestion> = new Map();

  // <deal_id, suggestion[]>
  storeIndexedByDealId: Map<string, AITaskSuggestion[]> = new Map();

  constructor() {
    makeAutoObservable(this);
  }

  getById(id: string): AITaskSuggestion | undefined {
    return this.store.get(id);
  }

  add(suggestion: AITaskSuggestionType) {
    const aiTaskSuggestion = new AITaskSuggestion(suggestion);
    this.store.set(aiTaskSuggestion.id, aiTaskSuggestion);

    const taskSuggestions =
      this.storeIndexedByDealId.get(aiTaskSuggestion.deal_id) || [];
    taskSuggestions.push(aiTaskSuggestion);
    this.storeIndexedByDealId.set(aiTaskSuggestion.deal_id, [
      ...taskSuggestions,
    ]);
  }

  remove(
    id: AITaskSuggestionType['id'],
    dealId: AITaskSuggestionType['deal_id'],
  ) {
    this.store.delete(id);

    const arr = this.storeIndexedByDealId.get(dealId) || [];
    const index = arr.findIndex((s) => s.id === id);
    if (index === -1) return;

    arr.splice(index, 1);
    this.storeIndexedByDealId.set(dealId, arr);
  }

  clear() {
    this.store.clear();
    this.storeIndexedByDealId.clear();
  }

  getSuggestionsByDealId(dealId: string): AITaskSuggestion[] {
    return this.storeIndexedByDealId.get(dealId) || [];
  }

  createTaskSuggestionFromDealTask(
    dealId: string,
    dealTask: {
      title: string;
      description: string;
      evidence: string[];
      why_blocking: string;
      priority: 'low' | 'medium' | 'high';
    },
  ): AITaskSuggestionType {
    const nowTimestamp = dayjs().valueOf();

    return {
      id: uuidv4(),
      created_at: nowTimestamp,
      deal_id: dealId,
      title: dealTask.title,
      description: dealTask.description,
      priority: dealTask.priority,
      evidence: dealTask.evidence,
      why_needed: dealTask.why_blocking,
    };
  }

  get all() {
    return Array.from(this.store.values());
  }

  // saveAITaskSuggestionDecision(
  //   id: AITaskSuggestionType['id'],
  //   decision: 'accepted' | 'dismissed',
  // ) {
  //   const suggestion = this.getById(id);
  //   if (!suggestion) return;

  //   pdkAxios.post('/ml/save-ai-task-suggestion', {
  //     id,
  //     entity_name: 'task',
  //     record_id: suggestion.deal_id,
  //     accepted: decision === 'accepted',
  //     dismissed: decision === 'dismissed',
  //     task_description: suggestion.task_description,
  //     priority: suggestion.priority,
  //   });
  // }
}

export const aiTaskSuggestions = new AITaskSuggestions();
